import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import home from "@/components/home.vue";
import token from "@/components/token.vue";
import planning from "@/components/planning.vue";

const routes = [
  {
    path: "/",
    component: home
  },
  {
    path: "/home",
    name: "home",
    component: home
  },
  {
    path: "/token",
    name: "token",
    component: token
  },
  {
    path: "/planning",
    name: "planning",
    component: planning
  }
];

const router = new VueRouter({ mode: "history", routes });

export default router;
